import { IQueryParamFilters } from '../../../shared/services/api.service';
import { IConfig } from '../../../url-reader';

export const getUrlParamFilters = (config: IConfig): IQueryParamFilters => ({
  size: config?.size,
  q: config?.query,
  social_feed_id: config?.social_feed_id,
  id: config?.id,
  language: config?.language,
  published_at: config?.published_at,
  sentiment: config?.sentiment,
  type: config?.type,
  tag: config?.tags,
  saved_filter_id: config?.saved_filter_id,
  product_sku: config?.product_sku,
  rating: config?.rating,
  sort: config?.sort,
  media_type: config?.media_type,
});
